export default __webpack_public_path__ + "static/media/Tu_Billetera_White.4b0f3b3b.svg";